import { IItemBranchesConfigurationValidation } from '../types/itemBranchesConfig';

export enum CONFIG_COLUMN {
  BRANCH = 'branch',
  SIZE = 'size',
  PRICE = 'price',
  DEFAULT_PRICE = 'default_price',
  AVAILABILITY = 'availability',
  IN_STOCK = 'in_stock',
}

export const defaultItemBranchesConfigurationValidation: IItemBranchesConfigurationValidation = {
  valid: true,
  price: true,
  available: true,
  out_of_stock: true,
};
